import React, { Component } from 'react';
import 'font-awesome/css/font-awesome.min.css';
import Balloon from '../components/chatBalloon';
import { Text } from '@app-masters/react-lib';

class Cellphone extends Component {
    render () {
        const push = this.props.interaction.options[0];
        return (
            <div className='view-background cellphone-bg' onClick={() => this.props.action(push.value)}>
                <div className='speakerWrapper'>
                    <div className='speaker' />
                </div>
                <div className='screen'>
                    <div className='statusBar'>
                        <div className='icons'>
                            <i className='fa fa-bluetooth-b' />
                            <i className='fa fa-wifi' />
                            <i className='fa fa-battery-three-quarters' />
                        </div>
                    </div>
                    <div className='messengerHeader'>
                        <div className='left'>
                            <i className='fa fa-2x fa-arrow-left' />
                            <div className='profilePicture' />
                            <div className='friendName'>{this.props.interaction.from}</div>
                        </div>
                        <div className='right'>
                            <i className='fa fa-2x fa-phone' />
                            <i className='fa fa-2x fa-paperclip' />
                            <i className='fa fa-2x fa-ellipsis-v' />
                        </div>
                    </div>
                    <div className='messengerSpeechSpace'>
                        <Balloon
                            name={this.props.interaction.from}
                            message={Text.nl2br(this.props.interaction.content.message)}
                        />
                    </div>
                </div>
                <div className='homeButtonWrapper'>
                    <div className='homeButton' />
                </div>
            </div>
        );
    }
}

export default Cellphone;



// WEBPACK FOOTER //
// ./src/views/InteractionViews/cellphoneView.js